import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';

// Mirrors SearchSuggestionRow's geometry so the placeholder occupies exactly
// the space the real row will. Each component owns its own styles, so these
// values are repeated rather than imported from the sibling.
const useStyles = createUseStyles(
  {
    row: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s12,
      padding: [Spacings.s8, Spacings.s12],
    },
    thumbnail: {
      flexShrink: 0,
    },
    text: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s8,
      flex: 1,
      minWidth: 0,
    },
  },
  { name: 'search-suggestion-row-skeleton' }
);

export default useStyles;
